<template>
  <div class="it-footer-small-prints clearfix">
    <div class="container">
      <h3 class="sr-only">Sezione Link Utili</h3>
      <ul class="it-footer-small-prints-list list-inline mb-0 d-flex flex-column flex-md-row">
        <li class="list-inline-item">
          <a href="#" title="Note Legali">Note legali</a>
        </li>
        <li class="list-inline-item">
          <a href="#" title="Privacy-Cookies">Privacy policy</a>
        </li>
        <li class="list-inline-item">
          <a href="#" title="Mappa del sito">Mappa del sito</a>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'FooterBottom',
  data() {
    return {
      icons: {
        itDesignersItalia: `${sprites}#it-designers-italia`,
      },
    };
  },
  components: {
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/footer/FooterBottom.vue